// @flow
export const SET_SETTINGS = 'settings/set_settings'

type State = {
  settings: Object,
}

type Action = {
  type: string,
  payload: any,
}

const initialState: State = {
  settings: {},
}

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case SET_SETTINGS:
      return {
        ...state,
        settings: action.payload,
      }
    default:
      return state
  }
}
